//import Vue from 'vue'
import i18n from '@/_helpers/lang'
import Swal from 'sweetalert2';

export const notification = {
    
    success(txt) {
        this.swalMessage('success', txt);
    },
    warning(txt) {
        this.swalMessage('warning', txt);
    },
    error(txt) {
        this.swalMessage('error', txt);
    },
    swalMessage(type, txt) {

        //si existe la traducción la cogemos
        if(!txt.startsWith('messages.') && i18n.te('messages.' + txt)) txt = 'messages.' + txt;

        Swal.fire({
            title: type==='success' ? 'Todo bien' : type==='warning' ? 'Atención' : 'Ops...',
            text: i18n.t(txt),
            position: 'top-end',
            icon: type,
            backdrop: false,
            background: type==='success' ? '#efffef' : type==='warning' ? '#f8fc70 ' : '#fff',
            showConfirmButton: false,
            timer: type==='success' ? 4000 : type==='warning' ? 6000  : 10000,
            timerProgressBar: true,
            width: '28rem',
            customClass: { container:'mySwal'},
            showCloseButton: true,
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
              },
        })		
    }
};